import React, { Component } from 'react';

class GoTop extends React.Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){
        var goTop = document.querySelector('.go_top');
        var isTop = true;
    
        goTop.addEventListener('click', (e)=>{
            window.scrollTo({'top':0});
            e.preventDefault();
        });

        window.addEventListener('scroll', () => {
            let winSc = window.pageYOffset;

            if(!isTop){
                if(winSc == 0){
                    isTop = true;
                    goTop.classList.remove('on');
                } 
            } else{
                if(winSc > 0){
                    isTop = false;
                    goTop.classList.add('on');

                } 
            }
        });
    
    }

    render(){
        return (
            
            <React.Fragment>
                <a href="#" className="go_top"></a>
            </React.Fragment>
        )
    }
}

export default GoTop;